import type { BadgeWonNotificationPayload as RawBadgeWonNotificationPayload } from '@dolfin/business/custom_types'
import {
  normalizeBadgeConfig,
  type MotivationalBadgeConfig
} from '../settings/motivational-features/types'

export interface BadgeWonNotificationPayload
  extends Omit<RawBadgeWonNotificationPayload, 'badgeConfig'> {
  badgeConfig: MotivationalBadgeConfig
}

export function normalizeBadgeWonNotificationPayload(
  payload: unknown
): BadgeWonNotificationPayload | null {
  if (typeof payload !== 'object' || payload === null) {
    return null
  }

  const candidate = payload as Partial<RawBadgeWonNotificationPayload>

  if (
    typeof candidate.issuedBadgeId !== 'string' ||
    typeof candidate.badgeId !== 'number' ||
    typeof candidate.badgeName !== 'string' ||
    typeof candidate.winnerDisplayName !== 'string' ||
    typeof candidate.source !== 'string' ||
    typeof candidate.sourceLabel !== 'string' ||
    typeof candidate.awardedAt !== 'string'
  ) {
    return null
  }

  if (candidate.source !== 'challenge' && candidate.source !== 'manual') {
    return null
  }

  return {
    awardedAt: candidate.awardedAt,
    badgeConfig: normalizeBadgeConfig(candidate.badgeConfig),
    badgeId: candidate.badgeId,
    badgeName: candidate.badgeName,
    issuedBadgeId: candidate.issuedBadgeId,
    source: candidate.source,
    sourceLabel: candidate.sourceLabel,
    winnerDisplayName: candidate.winnerDisplayName
  }
}
